<template>
  <div>
      <h2>Test Page</h2>

      <div class="row">
          <p class="col-12">Selected Language: {{ app.language.name }}</p>
          <p class="col-12">Selected Market: {{ app.market.name }}</p>
          <p class="col-12">Selected Configurator: {{ app.currentConfiguration.configurator.name }}</p>
          <p class="col-12">API baseURL: {{ app.API.baseURL }}</p>
      </div>

      <div class="row">
          <select-attribute-value 
            :parameter='languageParameter'
            :value.sync="app.language"
            ></select-attribute-value >
          <select-attribute-value 
            :parameter='marketParameter'
            :value.sync='app.market'></select-attribute-value>
          <select-attribute-value 
            :parameter='configuratorParameter'
            :value.sync='app.currentConfiguration.configurator'
            @update:value="refreshData"></select-attribute-value>
          <p class="col-12">API URL: <input type="text" size=120 v-model="app.API.baseURL" /></p>
          <button @click="refreshData">Actualizar</button>
      </div>

      <div class="row">        
        <p v-for="parameter in app.currentConfiguration.familyParameters" 
          :key='parameter.attribute.id' class='col-sm-12'>
            <strong>{{ parameter.attribute.name}}: </strong>
            {{ parameter.value.name}}
        </p>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-2"
          v-for="parameter in app.currentConfiguration.familyParameters" 
          :key='parameter.attribute.id'>

          <select-attribute-value 
            :parameter='parameter'
            :value.sync='parameter.value'
            @update:value='postData'></select-attribute-value>
        </div>
      </div>

      <button @click='postData'>Post</button>

  </div>
</template>

<script>

import { app } from './../application.js'
import selectAttributeValue from './selectAttributeValue.vue'
import attribute from '../models/attribute.js'
import parameter from '../models/parameter.js'
import configuration from '../models/configuration.js'

export default{
    name: 'testComponent',
    data () {
        var self=this;

        return {
          languageParameter: new parameter(
            new attribute('idioma','Idioma:'),
            'dropdown'),
          marketParameter: new parameter(
            new attribute('market','Mercado:'),
            'dropdown'),
          configuratorParameter: new parameter(
            new attribute('configurador','Configurador:'),
            'dropdown'),
          configuration: new configuration(),          
          language: new attribute(),
          market: new attribute(),
          app: app
        }
    },
    computed:{
        
    },

    methods: {
        refreshData: function(){
            var self = this;


            // V1
            // app.API.get(
            //     'test/getParameters/' + app.currentConfiguration.configurator.id,
            //     function(result){
            //         app.currentConfiguration.familyParameters = result;
            //         console.log(result);
            //     });

            // return;

            // V2
            // Netegem primer els parametres actuals
            app.currentConfiguration.language = app.language;
            app.currentConfiguration.market = app.market;
            app.currentConfiguration.stage = 2;
            app.currentConfiguration.familyParameters = [];

            // Fem el post inicial per omplir els familyParameters
            app.API.post(
                'configuration/process/',
                app.currentConfiguration,
                function(result){
                    app.currentConfiguration = result;
                    console.log(result);
                });
        }, 
        postData: function(){
            var self=this;

            // V1
            // app.API.post(
            //     'test/postParameters/' + app.currentConfiguration.configurator.id,
            //     app.currentConfiguration.familyParameters,
            //     function(result){
            //         console.log(result);
            //         app.currentConfiguration.familyParameters = result;
            //     });

            // Fem el post inicial per omplir els familyParameters
            app.API.post(
                'configuration/process',
                app.currentConfiguration,
                function(result){
                    app.currentConfiguration = result;
                    console.log(result);
                });
        }
    },
    beforeMount(){
        // console.log('beforeMount');
        var component=this;

        component.languageParameter = new parameter(
            new attribute('idioma','Idioma:'),
            'dropdown');
        component.marketParameter = new parameter(
            new attribute('market','Mercado:'),
            'dropdown');
        component.configuratorParameter = new parameter(
            new attribute('configurador','Configurador:'),
            'dropdown');

        // Load available languages
        app.API.getAttributeValues(
          'idioma',
          function(result){
              component.languageParameter.values = result;
          })

        // Load available markets
        app.API.getAttributeValues(
          'market',
          function(result){
              component.marketParameter.values = result;
          });
        
        // Load available markets
        app.API.getAttributeValues(
          'configurador',
          function(result){
              component.configuratorParameter.values = result;
          });

        this.refreshData();
    },
    components: {
      selectAttributeValue
    },
    props: {
        
  }
}
</script>

<style lang="scss">

</style>
